/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Roles_Edit_Application_ScopeInputs */

const en_forms_roles_edit_application_scope = /** @type {(inputs: Forms_Roles_Edit_Application_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Application Scope`)
};

const de_forms_roles_edit_application_scope = /** @type {(inputs: Forms_Roles_Edit_Application_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geltungsbereich Anwendung`)
};

/**
* | output |
* | --- |
* | "Application Scope" |
*
* @param {Forms_Roles_Edit_Application_ScopeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_roles_edit_application_scope = /** @type {((inputs?: Forms_Roles_Edit_Application_ScopeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Roles_Edit_Application_ScopeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_roles_edit_application_scope(inputs)
	return de_forms_roles_edit_application_scope(inputs)
});